<template>
  <div class="windowFooter">

  </div>
</template>

<script>
  export default {
    name: 'WindowFooter'
  }
</script>


// WEBPACK FOOTER //
// src/components/common/WindowFooter.vue